import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ProductType } from 'types/product';

type Props = {
  data?: ProductType;
  className?: string;
};

export default function WeeklySold(props: Props) {
  const { sold_count_ui } = props?.data || {};

  const weekSoldCount = sold_count_ui !== '0' ? sold_count_ui : ''; // 格式化显示的周销量

  return weekSoldCount ? (
    <div
      data-testid="wid-product-card-weekly-sold"
      className={twMerge(
        'inline-block mb-100 py-50 px-100 enki-body-3xs-strong rounded-200 text-surface-200-fg-default bg-surface-200-bg uppercase',
        props.className
      )}>
      {sold_count_ui}
    </div>
  ) : null;
}
